module.exports = __webpack_public_path__ + "a6bc0754832c049823d0d1de65e350fa.pdf";